import { PropsWithChildren, ReactElement, useCallback, useEffect, useState } from 'react'
import { useInjection } from 'inversify-react'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { Security } from '@okta/okta-react'
import { KibsiAuthConfigProvider } from '../service/api/kibsi.auth.config'
import { Environment } from '../config/environment'
import { getOktaAuthConfig } from './config'
import T from '../config/inversify.types'

export function AuthProvider<P>({ children }: PropsWithChildren<P>): ReactElement {
    const env = useInjection<Environment>(T.Environment)
    const api = useInjection<KibsiAuthConfigProvider>(T.KibsiApiConfig)
    const [okta] = useState(() => new OktaAuth(getOktaAuthConfig(env)))

    useEffect(() => {
        api.setTokenProvider(async () => okta.getAccessToken())
    }, [api, okta])

    const onRedirectCallback = useCallback((_: OktaAuth, originalUri: string) => {
        window.location.href = toRelativeUrl(originalUri || '/', window.location.origin)
    }, [])

    return (
        <Security oktaAuth={okta} restoreOriginalUri={onRedirectCallback}>
            {children}
        </Security>
    )
}
